import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13 7H3M10 12H3M8 17H3",
      stroke: "#1C274C",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.316 16.692a.75.75 0 1 0 1.368.616l-1.368-.616ZM16.5 7l.684-.308a.75.75 0 0 0-1.368 0L16.5 7Zm3.816 10.308a.75.75 0 1 0 1.368-.616l-1.368.616Zm-.952-3.944.684-.308-.684.308Zm-5.728-.75a.75.75 0 0 0 0 1.5v-1.5Zm-.952 4.694 4.5-10-1.368-.616-4.5 10 1.368.616Zm9-.616-1.636-3.636-1.368.615 1.636 3.637 1.368-.616Zm-1.636-3.636-2.864-6.364-1.368.616 2.864 6.363 1.368-.615Zm-.684-.442h-5.728v1.5h5.728v-1.5Z",
      fill: "#1C274C"
    }, null, -1)
  ]))]))
}
export default { render };